import { EKnowledgeShareMode } from "@frontend-shared/types";

// NOTE: Canonical field keys come from the server (EAssistantChangedField).
// Mapped to literal i18n keys so react-i18next strict typing doesn't widen
// to `string`. Unknown keys fall through to the raw value — keeps the card
// forward-compatible if the server adds a new field before the catalog
// catches up.
export const FIELD_LABEL_KEYS = {
  name: "type.assistant_edited.fields.name",
  description: "type.assistant_edited.fields.description",
  instructions: "type.assistant_edited.fields.instructions",
  avatar: "type.assistant_edited.fields.avatar",
  model: "type.assistant_edited.fields.model",
  files: "type.assistant_edited.fields.files",
  integrations: "type.assistant_edited.fields.integrations",
  docs_support: "type.assistant_edited.fields.docs_support",
  images_support: "type.assistant_edited.fields.images_support",
} as const;

// NOTE: Per-mode i18n keys kept as literal strings so the strict react-i18next
// typing doesn't widen to `string`. Using a Record lookup (instead of a
// switch) preserves TS exhaustiveness over EKnowledgeShareMode without
// tripping ESLint's `consistent-return` on the implicit fall-through path.
export const BODY_KEY_BY_SHARE_MODE = {
  [EKnowledgeShareMode.DIRECT]: "type.knowledge_file_shared.body_direct",
  [EKnowledgeShareMode.PROJECT_ALL]:
    "type.knowledge_file_shared.body_project_all",
  [EKnowledgeShareMode.PUBLIC]: "type.knowledge_file_shared.body_public",
} as const;

// NOTE: NSAI-5327 — a reminder body is user/agent markdown, and its `#`
// headings rendered larger than the card's own title. Flatten every heading
// level to the card's 14px body size, bold, so no heading outgrows the title.
// Per-level variants on purpose: `prose-headings` also matches table `th`.
export const FLAT_MARKDOWN_HEADING_CLASSES =
  "prose-h1:my-1 prose-h2:my-1 prose-h3:my-1 prose-h4:my-1 prose-h5:my-1 prose-h6:my-1 prose-h1:text-sm prose-h2:text-sm prose-h3:text-sm prose-h4:text-sm prose-h5:text-sm prose-h6:text-sm prose-h1:font-semibold prose-h2:font-semibold prose-h3:font-semibold prose-h4:font-semibold prose-h5:font-semibold prose-h6:font-semibold prose-h1:leading-5 prose-h2:leading-5 prose-h3:leading-5 prose-h4:leading-5 prose-h5:leading-5 prose-h6:leading-5" as const;
